// на стр."Решения"
export function showSolutionCards() {
  const cards = document.querySelectorAll(
    ".avtomatizacziya-magazina-1177.avtomatizacziya-magazina-1177 .solution__card"
  );
  const showMoreBtn = document.querySelector(
    ".avtomatizacziya-magazina-1177 .solution__button-show"
  );

  if (!(cards.length && showMoreBtn)) return;

  cards.forEach((card, index) => {
    if (index >= 12) {
      card.classList.add("hidden");
    }
  });

  if (cards.length < 12) {
    showMoreBtn.style.display = "none";
  }

  showMoreBtn.addEventListener("click", () => {
    console.log("клик");

    cards.forEach(card => {
      card.style.display = "block";
    });

    showMoreBtn.style.display = "none";
  });
}

// На стр. Блог

export function showBlogCards() {
  const cards = document.querySelectorAll(
    ".avtomatizacziya-sklada-post .solution__card"
  );
  const showMoreBtn = document.querySelector(
    ".avtomatizacziya-sklada-post .other-solutions__button-show"
  );

  if (!(cards.length && showMoreBtn)) return;

  cards.forEach((card, index) => {
    if (index >= 4) {
      card.classList.add("hidden");
    }
  });

  if (cards.length < 4) {
    showMoreBtn.style.display = "none";
  }

  showMoreBtn.addEventListener("click", () => {
    cards.forEach(card => {
      card.style.display = "block";
    });

    showMoreBtn.style.display = "none";
  });
}

export function showSolutionPageCards() {
  const loadMoreButton = document.querySelectorAll(".load-more-btn"),
    showMoreBuilder = document.querySelectorAll(".show-button-build"),
    sortItems = document.querySelectorAll(".sort__item");
  if (loadMoreButton) {
    loadMoreButton.forEach(btn => {
      btn.addEventListener("click", async e => {
        e.preventDefault();
        const categoryId = +btn.dataset.categoryId,
          postsPerPage = +btn.dataset.postsPerPage,
          postType = btn.dataset.postType,
          template = btn.dataset.template;
        let page = +btn.dataset.page;
        page++;

        const fd = new FormData();
        fd.append("category_id", categoryId);
        fd.append("paged", page);
        fd.append("posts_per_page", postsPerPage);
        fd.append("post_type", postType);
        fd.append("template", template);

        await fetch(
          VARS.ajax_url
            .toString()
            .replace("%%endpoint%%", "ems_sklad_load_more_posts"),
          {
            method: "POST",
            body: fd,
          }
        )
          .then(r => r.text())
          .then(html => {
            btn.setAttribute("disabled", true);

            btn.dataset.page = page;
            const doc = extractedHtml(html),
              newCards = doc.querySelectorAll(".solution__card"),
              container = document.querySelector(".solution__cards");

            newCards.forEach(card => {
              container.appendChild(card);
            });

            const btnPostPerPage = btn.querySelector(".post-per-page"),
              totalPostsPerPage = +btnPostPerPage.textContent - postsPerPage;
            btnPostPerPage.textContent = totalPostsPerPage;

            if (newCards.length < postsPerPage || totalPostsPerPage <= 0) {
              btn.remove();
            }
          })
          .finally(() => {
            btn.removeAttribute("disabled");
          });
      });
    });
  }

  if (showMoreBuilder) {
    showMoreBuilder.forEach(btn => {
      btn.addEventListener("click", async event => {
        event.preventDefault();

        const fd = new FormData();
        for (const i in btn.dataset) {
          fd.append(i, btn.dataset[i]);
        }

        await fetch(
          VARS.ajax_url
            .toString()
            .replace("%%endpoint%%", "ems_sklad_load_more"),
          {
            method: "POST",
            body: fd,
          }
        )
          .then(r => r.text())
          .then(html => {
            const doc = extractedHtml(html, btn.dataset?.template),
              bodyClassName = doc.querySelector("body").className;

            switch (bodyClassName) {
              case "article":
                const articles = doc.querySelectorAll(".blog__card");

                if (articles) {
                  articles.forEach(article => {
                    document.querySelector(".blog__cards").append(article);
                  });
                  incrementDataPage(btn);
                }

                removeButton(btn, articles.length);
                break;
              case "func_service":
                const functionalityCards = doc.querySelectorAll(
                  ".functionality__card"
                );
                if (functionalityCards) {
                  functionalityCards.forEach(a => {
                    document.querySelector(".solution__cards").append(a);
                  });
                  incrementDataPage(btn);
                }
                removeButton(btn, functionalityCards.length);
                break;
              default:
                const solutionsCards = doc.querySelectorAll(".solution__card");

                if (solutionsCards) {
                  solutionsCards.forEach(card => {
                    document.querySelector(".solution__cards").append(card);
                  });
                  incrementDataPage(btn);
                }
                removeButton(btn, solutionsCards.length);
                if (
                  !solutionsCards.length ||
                  solutionsCards.length < +btn.dataset.paged
                ) {
                  btn.remove();
                }
            }
          });
      });
    });
  }

  if (sortItems) {
    sortItems.forEach(item => {
      item.addEventListener("click", () => {
        console.log(item.dataset);
      });
    });
  }
}

function extractedHtml(html, className) {
  const parser = new DOMParser(),
    doc = parser.parseFromString(html, "text/html");
  if (className) {
    doc.querySelector("body").classList.add(className);
  } else {
    doc.querySelector("body").classList.add("default");
  }

  return doc;
}

function incrementDataPage(btn) {
  const p = +btn.dataset.paged;
  btn.dataset.paged = p + 1;
}

function removeButton(btn, itemsLength) {
  if (!itemsLength || itemsLength < +btn.dataset.perPage) {
    btn.remove();
  }
}
